import { useMemo } from 'react';
import { Units } from '@ais-ui/utils';
import { getLengthUnit } from './utils';
import { useSettings } from '../Settings/SettingsProvider';

/**
 * Returns the user's preferred unit system (METRIC, IMPERIAL, or MARITIME).
 * Use this when you need just the system choice without length-specific formatting.
 */
export function useUnitSystem(): Units {
  const { settings } = useSettings();
  return useMemo(() => getLengthUnit(settings), [settings]);
}
